module.exports = __webpack_public_path__ + "img/parking-lot-0.d5273c5a.jpg";